import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { getSessionToken } from '../utils/session-token';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (getSessionToken()) {
    return true;
  }

  return router.createUrlTree(['/authentication/login']);
};

export const authChildGuard: CanActivateChildFn = () => {
  const router = inject(Router);
  if (getSessionToken()) {
    return true;
  }

  return router.createUrlTree(['/authentication/login']);
};

export const guestGuard: CanActivateFn = () => {
  const router = inject(Router);
  if (!getSessionToken()) {
    return true;
  }

  return router.createUrlTree(['/dashboard/home']);
};
